import axios from 'axios';
import {
	GET_PRODUCT_SUCCESS,
	GET_PRODUCT_FAIL,
	SET_ALERT,
	CLEAR_PRODUCTS,
} from './index';
const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';
let prevFilterKey = null;

export const getAllProducts = (offset, categoryID, subcategoryID?) => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
		},
	};

	const filterKey = `${categoryID}-${subcategoryID}`;
	if (filterKey !== prevFilterKey) {
		dispatch({ type: 'CLEAR_PRODUCTS' });
	}
	prevFilterKey = filterKey;

	try {
		let url = `${BASE_URL}/api/get-user-products?offset=${offset}&categoryID=${categoryID}`;
		if (subcategoryID) url += `&subcategoryID=${subcategoryID}`;
		const response = await axios.get(url, config);
		if (response.data != null) {
			dispatch({ type: GET_PRODUCT_SUCCESS, payload: response.data });
		} else {
			dispatch({
				type: SET_ALERT,
				payload: { message: 'No more products', status: 'error' },
			});
		}
	} catch (e) {
		dispatch({ type: GET_PRODUCT_FAIL });
	}
};
